var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: _vm.title,
        width: 500,
        ok: false,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        okText: this.$store.getters.language["common.okButton"],
        cancelText: _vm.language["common.closeButton"]
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel }
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model",
            { ref: "form", staticStyle: { "margin-bottom": "0" } },
            [
              _c(
                "a-form-model-item",
                {
                  staticStyle: { "margin-bottom": "0" },
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    label:
                      _vm.language["eletronicSigned.cancelOrTerminationCause"]
                  }
                },
                [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.comments,
                        expression: "comments"
                      }
                    ],
                    staticStyle: {
                      width: "100%",
                      "border-radius": "5px",
                      "line-height": "1.5"
                    },
                    attrs: { rows: "5", cols: "25", maxLength: "1000" },
                    domProps: { value: _vm.comments },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.comments = $event.target.value
                      }
                    }
                  })
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }